import { render, staticRenderFns } from "./plan-template-view.vue?vue&type=template&id=656954a8"
import script from "./plan-template-view.vue?vue&type=script&lang=js"
export * from "./plan-template-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports